function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { textFieldClasses } from '@mui/material/TextField';
import { arrayOf, bool, func, string, instanceOf, oneOfType } from 'prop-types';
import { styled } from '@mui/material/styles';
import clsx from 'clsx';
import SovosDatePicker from '../sovos-date-picker';
import SovosFilterDrawerSection from '../sovos-filter-drawer-section';
const Root = styled(SovosFilterDrawerSection)(_ref => {
  let {
    theme: {
      spacing
    }
  } = _ref;
  return {
    '& .sovosFilterDateInput__input': {
      marginBlockEnd: spacing(),
      ["&.".concat(textFieldClasses.root)]: {
        minHeight: 'auto'
      }
    }
  };
});

/**
 * For use in `SovosFilterDrawer`
 */
const SovosFilterDateInput = _ref2 => {
  let {
    className,
    data = [],
    'data-testid': dataTestId,
    format = 'MM/dd/yyyy',
    label,
    maxDate,
    minDate,
    multiple = false,
    onChange,
    ...rest
  } = _ref2;
  const getRow = _ref3 => {
    let {
      entry,
      handleChange
    } = _ref3;
    return /*#__PURE__*/React.createElement(SovosDatePicker, {
      className: "sovosFilterDateInput__input",
      format: format,
      maxDate: maxDate,
      minDate: minDate,
      onChange: value => handleChange({
        target: {
          value
        }
      }, value),
      TextFieldProps: {
        fullWidth: true,
        size: 'small'
      },
      value: entry
    });
  };
  getRow.propTypes = {
    entry: string.isRequired,
    handleChange: func.isRequired
  };
  return /*#__PURE__*/React.createElement(Root, _extends({
    className: clsx('sovosFilterDateInput', className),
    data: data,
    "data-testid": dataTestId,
    getRow: getRow,
    label: label,
    multiple: multiple,
    onChange: onChange
  }, rest));
};
SovosFilterDateInput.propTypes = {
  /**
   * Extend the class name applied to the root element
   */
  className: string,
  /**
   * The date values to render. An array of date objects or strings in the
   * specified format
   */
  data: arrayOf(oneOfType([instanceOf(Date), string])),
  /**
   * @ignore
   */
  'data-testid': string,
  /**
   * Date format string used as a placeholder and validator for the input
   */
  format: string,
  /**
   * Section label
   */
  label: string.isRequired,
  /**
   * Maximum allowed date
   */
  maxDate: oneOfType([instanceOf(Date), string]),
  /**
   * Minimum allowed date
   */
  minDate: oneOfType([instanceOf(Date), string]),
  /**
   * When true, the user can add an arbitrary number of dates
   */
  multiple: bool,
  /**
   * Callback fired when the input value is changed `function(data:
   * string[]) => void`
   */
  onChange: func.isRequired
};
export default SovosFilterDateInput;